import { Attribute, Bucket } from "@cartographerio/atlas-map";
import { expr, MapboxExpr } from "../mapbox";
import { bucketFilterExpr } from "./paint";

export function attributeFilter(
  attr: Attribute,
  buckets: Bucket[]
): MapboxExpr | undefined {
  switch (attr.type) {
    case "SimpleAttribute": {
      return undefined;
    }

    case "PropertyAttribute": {
      if (buckets.length === 0) {
        return undefined;
      } else {
        const getExpr: MapboxExpr = expr.get(attr.propertyName);

        return expr.any(
          ...buckets.map(bucket => bucketFilterExpr(bucket, getExpr))
        );
      }
    }
  }
}
